
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import moment from "moment";
import DataUtils from '@/utils/DataUtils';
import { C30101ScheduleTableDataParser } from './comp/C30101ScheduleTableMixin';

const module = {
  state: {
    // set default here
    searchInfo: {

    },
    // PgC30101
    init_PageformData: {
      selectedStudent: null,
      selectedSubject: {},
      classStartDate: moment().add(0, 'weeks').isoWeekday(1).format('YYYY-MM-DD'),

      classType: 1, // 1: レギュラー, 2: 単発, 3: 講習会
      insertScheduleList: [], // New Schedule
      deleteScheduleList: [], // Delete Schedule (entry_schedule_no)
      overallSubjectDate: [],// keep track all subject date

      isDirty: false,
    },

    PageformData: {

    },

    // t0050_calendar, t0060_seminar_calendar (event), t0061_regular_control (locked)
    t0050_calendar: [],

    t1030_entry_schedule_week: [], // regular
    t1031_entry_schedule: [],  // one time off and seminar
    t1032_not_attended_schedule: [],
    t3013_change_schedule: [],
    t1033_student_subject: [],
    t3010_schedule: [],
    t3015_cancel_schedule: [], // C30101_004
    //
    C30101_getCellTeacherCount: [],
    M1040_Schedule_Created_Date: null,
    // --- END REGION ----

    // 選択可能な科目 // 登録可能な科目 // 単発 // 講習会
    subjectGroup1: [],
    selectedSubject: [],

    scheduleTableStructure: [], // C30101-3

    // コース情報の表は、折りたたみ可能とする（アコーディオン）
    getSubjectSelectBox: [],
    // m1011_course_setting
    // - time_division
    DropDownTimeDivision: [
      { label: '90分', value: 0 },
      { label: '40分(前半)', value: 1 },
      { label: '40分(後半)', value: 2 },
    ],
    // - capacity
    DropDownCapacity: [
      { label: '1対1', value: 1 },
      { label: '1対2', value: 2 },
    ],
    // m1010_course
    C30101_getCourseDropdown: [],
    DropDownSubject: [],

    t0060_seminar_calendar: [],

    t0062_entry_control: [],

    C30101_getSelectableDateRange: {
      min: moment().subtract(1,'months').day(1).format('YYYY-MM-DD'),
      max: moment().add(3, 'months').endOf('month').day(7).format('YYYY-MM-DD')
    },

    /**
     * Get calender with seminar info
     */
    C30101_getCalender: [],

    contextMenu_mode: null,
    contextMenu_menuInput: null,

    t0063_regular_schedule_control: [],
  },

  getters: {
    debug_t1030_entry_schedule_week(state) {
      return state.t1030_entry_schedule_week.filter(item => !!item._action)
    },
    debug_t1031_entry_schedule(state) {
      return state.t1031_entry_schedule.filter(item => !!item._action)
    },
    debug_t1032_not_attended_schedule(state) {
      return state.t1032_not_attended_schedule.filter(item => !!item._action)
    },
    debug_t3013_change_schedule(state) {
      return state.t3013_change_schedule.filter(item => !!item._action)
    },
    debug_t1033_student_subject(state) {
      return state.t1033_student_subject.filter(item => !!item._action)
    },
    debug_t3010_schedule(state) {
      return state.t3010_schedule.filter(item => !!item._action)
    },
    debug_t3015_cancel_schedule(state) {
      return state.t3015_cancel_schedule.filter(item => !!item._action)
    },
    getIsOpenSlot: (state, getters) => (date, timeLimitNo) => {
      return getters.getIsOpenTimeLimitSlot(date, timeLimitNo) || getters.getIsOpenSeminarSlot(date, timeLimitNo)
    },
    getIsOpenTimeLimitSlot: (state) => (date, timeLimitNo) => {
      // find target calendatList item using schedule_Date
      const targetSchedule = state.t0050_calendar.find(item => item.schedule_date === date)
      if (!targetSchedule) throw new Error('Target schedule not found:' + date)
      if (targetSchedule.closed_flag) return false
      if (timeLimitNo >= targetSchedule.tstart_ime_limit_no && timeLimitNo <= targetSchedule.end_time_limit_no) return true
      return false
    },
    getIsOpenSeminarSlot: (state) => (date, timeLimitNo) => {
      const targetSchedule = state.t0050_calendar.find(item => item.schedule_date === date)
      if (!targetSchedule) throw new Error('Target schedule not found:' + date)
      if (targetSchedule.closed_flag) return false
      // const targetT0060 = state.t0060_seminar_calendar.find(item => item.schedule_start_date <= date && item.schedule_end_date >= date)
      // if (targetT0060 && timeLimitNo >= targetT0060.start_time_limit_no && timeLimitNo <= targetT0060.end_time_limit_no) return true
      if (state.t0060_seminar_calendar.find(item =>
        item.schedule_start_date <= date &&
        item.schedule_end_date >= date &&
        item.start_time_limit_no <= timeLimitNo &&
        item.end_time_limit_no >= timeLimitNo
      )) return true
      return false
    },
    checkSeminarAssignmentEligibility: (state) => (date) => {
      const targetT0060 = state.t0060_seminar_calendar.find(item => item.schedule_start_date <= date && item.schedule_end_date >= date)
      if (targetT0060 && moment().isBetween(targetT0060.entry_start_date, targetT0060.entry_end_date, "day", '[]')) return true
      return false
    },
    C30101ScheduleTableData: (state) => {
      return C30101ScheduleTableDataParser({
        t1030_entry_schedule_week: state.t1030_entry_schedule_week,
        t1031_entry_schedule: state.t1031_entry_schedule,
        t1032_not_attended_schedule: state.t1032_not_attended_schedule,
        t3010_schedule: state.t3010_schedule,
        t3013_change_schedule: state.t3013_change_schedule,
        t3015_cancel_schedule: state.t3015_cancel_schedule,
        t0062_entry_control: state.t0062_entry_control,
        t0063_regular_schedule_control: state.t0063_regular_schedule_control,
        C30101_getCalender: state.C30101_getCalender,
        C30101_getCellTeacherCount: state.C30101_getCellTeacherCount,
        classStartDate: moment(state.PageformData.classStartDate, 'YYYY-MM-DD').add(0, 'weeks').subtract(1,'days').day(1),
        classEndDate: state.C30101_getSelectableDateRange.max,
        calendarTimeSlot: $this.$store.getters['Auth/Auth_getTimeLimit_without0'],
      })
    },
    refactorGetNewRegularSetting: (state, getters) => ({ dayInfo, timeSlot, ctx }) => {
      const avilableChoice = state.t1030_entry_schedule_week.filter((course) => {
        return course.course_start_date === null
      })
      if (avilableChoice.length === 0) return []

      const debugMap = {};
      let i = 0;
      let currentDate = null
      console.log({
        dayInfo, timeSlot
      })

      const result = {
        allowDivision: {
          0: true,
          1: true,
          2: true
        },
        allowDivisionArray: []
      }

      while (i < 30) {
        currentDate = moment(dayInfo.schedule_date).add(i++, 'weeks').format('YYYY-MM-DD');
        debugMap[currentDate] = {};
        debugMap[currentDate].upperCellStatus = null
        debugMap[currentDate].lowerCellStatus = null
        debugMap[currentDate].index = i

        // check is occupied
        debugMap[currentDate].upperKey = `${currentDate}_${timeSlot.time_limit_group_no}1`
        debugMap[currentDate].upperCell = getters.C30101ScheduleTableData[debugMap[currentDate].upperKey]
        debugMap[currentDate].lowerKey = `${currentDate}_${timeSlot.time_limit_group_no}2`
        debugMap[currentDate].lowerCell = getters.C30101ScheduleTableData[debugMap[currentDate].lowerKey]

        // only check if cell exist
        if(!debugMap[currentDate].upperCell)
          break;

        if (debugMap[currentDate].upperCell && !['', '－'].includes(debugMap[currentDate].upperCell.label)) {
          debugMap[currentDate].upperCellStatus = 'occupied'
          result.allowDivision[0] = false
          result.allowDivision[1] = false
        }
        if (debugMap[currentDate].lowerCell && !['', '－'].includes(debugMap[currentDate].lowerCell.label)) {
          debugMap[currentDate].lowerCellStatus = 'occupied'
          result.allowDivision[0] = false
          result.allowDivision[2] = false
        }

        if (debugMap[currentDate].upperCell && debugMap[currentDate].upperCell.label === '－') {
          debugMap[currentDate].upperCellStatus = 'not open'
        }
        if (debugMap[currentDate].lowerCell && debugMap[currentDate].lowerCell.label === '－') {
          debugMap[currentDate].lowerCellStatus = 'not open'
        }
        debugMap[currentDate].index = i
        debugMap[currentDate].flag0 = result.allowDivision[0]
        debugMap[currentDate].flag1 = result.allowDivision[1]
        debugMap[currentDate].flag2 = result.allowDivision[2]
      }

      if (result.allowDivision[0]) result.allowDivisionArray.push(0)
      if (result.allowDivision[1]) result.allowDivisionArray.push(1)
      if (result.allowDivision[2]) result.allowDivisionArray.push(2)
      console.groupCollapsed('getNewRegularSetting')
      console.log('allowDivision:', result)
      console.table(avilableChoice)
      console.table(debugMap)
      console.groupEnd()

      return avilableChoice.filter((course) => {
        return result.allowDivisionArray.includes(course.time_division)
      })
    },
    getCellTeacherCount: (state) => (date, timeLimitNo) => {
      const key = `${date}_${timeLimitNo}`;
      const teacherCount = state.C30101_getCellTeacherCount[key];
      if (teacherCount)
        return teacherCount.rem_teacher_cnt;
      return 0;
    },
    getT0062EntryControlMap(state) {
      const map = {};
      state.t0062_entry_control.forEach(item => {
        map[`${item.schedule_date}_${item.time_limit_no}`] = item;
      });
      return map;
    },
    /**
     * 満席判定
     */
    getIsFullyBooked: (state, getters) => (date, timeLimitNo) => {
      if (getters.getT0062EntryControlMap[`${date}_${timeLimitNo}`])
        return true
      return getters.getCellTeacherCount(date, timeLimitNo) <= 1
    },
  },
  mutations: {
    setPageformData(state, payload) {
      state.PageformData = payload
    },
    insertt1030_entry_schedule_week(state, payload) {
      state.t1030_entry_schedule_week.push(payload)
    },
    insertt1031_entry_schedule(state, payload) {
      state.t1031_entry_schedule.push(payload)
    },
    setisDirty(state, payload) {
      state.PageformData.isDirty = payload
    },
    insertt3013_change_schedule(state, payload) {
      state.t3013_change_schedule.push(payload)
    },
    insertt1032_not_attended_schedule(state, payload) {
      state.t1032_not_attended_schedule.push(payload)
    },
    insertt3015_cancel_schedule(state, payload) {
      state.t3015_cancel_schedule.push(payload)
    },
    insertt3010_schedule(state, payload) {
      state.t3010_schedule.push(payload)
    },
  },
  actions: {
    // C30101-1
    // C30101-3
    async initState2({ state, commit }, payload) {
      commit('setState', {
        _removeReactivity: true, // Disable reactivity for performance
        t0050_calendar: [],
        t1030_entry_schedule_week: [],
        t1031_entry_schedule: [],
        t1033_student_subject: [],
        t3010_schedule: [],
        t1032_not_attended_schedule: [],
        t3013_change_schedule: [],
        t3015_cancel_schedule: [],
        C30101_getCalender: []
      });
      const res = await $this.$api.postData({
        data: {
          scheduleTableStructure: {
            api: 'M0040TimeLimitService.doBrowseAll',
            input: {
              searchInfo: {
                not_time_division: 0
              }
            }
          },
          C30101_getCourseDropdown: {
            api: 'M1010CourseService.C30101_getCourseDropdown',
            input: {}
          },
          getSubjectSelectBox: {
            api: 'M1020SubjectService.getSubjectSelectBox',
            input: {}
          },
          C30101_getSubjectByClassification: {
            api: 'M1020SubjectService.C30101_getSubjectByClassification',
            input: {
              student_classification: 0
            }
          },

          T0050Calendar: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          T1033StudentSubject: {
            api: 'T1033StudentSubjectService.C30101_doBrowseByStudentNo',
            input: {
              student_no: payload.student_no
            }
          },
          T0050CalendarTeacherCount: {
            api: 'T0050CalendarService.C30101_getCellTeacherCount',
            input: payload
          },
          M1040ScheduleCreatedDate: {
            api: 'M1040ScheduleCreatedDateService.C30101_getScheduleDateInfo',
            input: payload
          },
          T0060SeminarCalendar: {
            api: 'T0060SeminarCalendarService.C30101_getList',
            input: payload
          },
          t0062_entry_control: {
            api: 'T0062EntryControlService.C30101Student_doBrowse',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          C30101_getCalender: {
            api: 'T0050CalendarService.C30101_getCalender',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },
          C30101_ScheduleTable_editable: {
            api: 'T0050CalendarService.C30101_ScheduleTable_editable',
            input: payload
          },
          t0063_regular_schedule_control: {
            api: 'T0063RegularScheduleControlService.C30101_getRegularScheduleControl',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          },
        }
      });

      commit('setState', {
        // C30101Admin readonly
        scheduleTableStructure: res.scheduleTableStructure.output,
        C30101_getCourseDropdown: res.C30101_getCourseDropdown.output,
        getSubjectSelectBox: res.getSubjectSelectBox.output,
        subjectGroup1: res.C30101_getSubjectByClassification.output,
        DropDownSubject: res.C30101_getSubjectByClassification.output,
        M1040_Schedule_Created_Date: res.M1040ScheduleCreatedDate.output,
        t0050_calendar: res.T0050Calendar.output,
        t0060_seminar_calendar: res.T0060SeminarCalendar.output,

        // C30101Admin editable
        t1033_student_subject: res.T1033StudentSubject.output,

        // C30101ScheduleTableMixin readonly
        C30101_getCalender: res.C30101_getCalender.output,
        C30101_getCellTeacherCount: res.T0050CalendarTeacherCount.output,
        t0062_entry_control: res.t0062_entry_control.output,
        // C30101ScheduleTableMixin editable
        t1030_entry_schedule_week: res.C30101_ScheduleTable_editable.output.t1030_entry_schedule_week,
        t1031_entry_schedule: res.C30101_ScheduleTable_editable.output.t1031_entry_schedule,
        t1032_not_attended_schedule: res.C30101_ScheduleTable_editable.output.t1032_not_attended_schedule,
        t3010_schedule: res.C30101_ScheduleTable_editable.output.t3010_schedule,
        t3013_change_schedule: res.C30101_ScheduleTable_editable.output.t3013_change_schedule,
        t3015_cancel_schedule: res.C30101_ScheduleTable_editable.output.t3015_cancel_schedule,
        t0063_regular_schedule_control: res.t0063_regular_schedule_control.output,
      });
    },
    async C30101_submit({ state }, payload) {
      // create a array filter that removes item without `_action` key
      const itemWithActionProperties = (item) => {
        return item._action
      }

      const result = await $this.$api.postData({
        data: [
          {
            api: 'T1030EntryScheduleWeekService.C30101_submit',
            input: {
              student_no: state.PageformData.selectedStudent.student_no,
              belongs_center_no: state.PageformData.selectedStudent.belongs_center_no,
              t1030_entry_schedule_week: state.t1030_entry_schedule_week.filter(itemWithActionProperties),
              t1031_entry_schedule: state.t1031_entry_schedule.filter(itemWithActionProperties),
              t1032_not_attended_schedule: state.t1032_not_attended_schedule.filter(itemWithActionProperties),
              t3013_change_schedule: state.t3013_change_schedule.filter(itemWithActionProperties),
              t1033_student_subject: state.t1033_student_subject.filter(itemWithActionProperties),
              t3010_schedule: state.t3010_schedule.filter(itemWithActionProperties),
              t3015_cancel_schedule: state.t3015_cancel_schedule.filter(itemWithActionProperties),
            }
          }
        ],
        databaseDiff: {
          tables: [
            't1030_entry_schedule_week',
            't1031_entry_schedule',
            't1032_not_attended_schedule',
            't3013_change_schedule',
            't1033_student_subject',
            't3010_schedule',
            't3015_cancel_schedule',
          ]
        }
      })
      return result[0].output;
    },
    async C30101_004_Function({ state, commit, getters }, { dayInfo, timeSlot, subjectInfo, index2, ctx }) {
      let timeData = null

      const temp = {
        0: '(90分)',
        1: '(40分前半)',
        2: '(40分後半)',
      }
      timeData = `${moment(dayInfo.schedule_date).format('YYYY/MM/DD (dd)')} ${timeSlot.time_limit_group_name} ${temp[subjectInfo.time_division]}`

      const result = await $this.$dialogManager.openDialog('C30101InsertRegularWithEndDialog', {
        courseInfoTitle: `${subjectInfo.subject_name3} [${subjectInfo.time_division === 0 ? 90 : 40}分 ${subjectInfo.capacity_label} ${subjectInfo.course_label}]`,
        timeData
      }, {
        count: 1
      })
      const numWeek = result.count

      if (!numWeek) {
        // ctx.$dialog.notify.info('Regular schedule insertion cancelled.');
        return
      }
      // get date list from startDate and numWeek
      const debugMap = {};
      let i = 0;
      let currentDate = null
      let createdIndex = 0;
      console.log({
        dayInfo, timeSlot, subjectInfo, numWeek
      })

      if (numWeek <= 0) throw new Error('numWeek must be greater than 0')
      while (createdIndex < numWeek) {

        currentDate = moment(dayInfo.schedule_date).add(i++, 'weeks').format('YYYY-MM-DD');
        debugMap[currentDate] = {};
        let skip = false;

        // check is occupied
        debugMap[currentDate].upperCellKey = `${currentDate}_${timeSlot.time_limit_group_no}1`
        debugMap[currentDate].upperCell = getters.C30101ScheduleTableData[debugMap[currentDate].upperCellKey]
        debugMap[currentDate].lowerCellKey = `${currentDate}_${timeSlot.time_limit_group_no}2`
        debugMap[currentDate].lowerCell = getters.C30101ScheduleTableData[debugMap[currentDate].lowerCellKey]

        switch (subjectInfo.time_division) {
          case 0:
            if (debugMap[currentDate].upperCell && !['', '－'].includes(debugMap[currentDate].upperCell.label)) skip = true
            if (debugMap[currentDate].lowerCell && !['', '－'].includes(debugMap[currentDate].lowerCell.label)) skip = true
            break;
          case 1:
            if (debugMap[currentDate].upperCell && !['', '－'].includes(debugMap[currentDate].upperCell.label)) skip = true
            break;
          case 2:
            if (debugMap[currentDate].lowerCell && !['', '－'].includes(debugMap[currentDate].lowerCell.label)) skip = true
            break;
          default:
            console.warn('Unknown time_division:', subjectInfo.time_division)
            break;
        }
        if (skip) debugMap[currentDate].c = 'occupied'

        // check
        if (debugMap[currentDate].upperCell && debugMap[currentDate].upperCell.label === '－') {
          debugMap[currentDate].c = 'not open'
          skip = true
        }
        if (debugMap[currentDate].lowerCell && debugMap[currentDate].lowerCell.label === '－') {
          debugMap[currentDate].c = 'not open'
          skip = true
        }

        if(state.t0063_regular_schedule_control.find(item =>
          item.schedule_date === currentDate
        )){
          debugMap[currentDate].c = 't0063'
          skip = true
        }

        if (skip) {
          if (debugMap[currentDate].c === 'occupied') {
            // add to 3015
            const t3015base = {
              "id": DataUtils.randomString(5),
              "_action": 'add',
              "schedule_no": 's3010_schedule_no', // need generate using s3010_schedule_no seq
              "student_no": state.PageformData.selectedStudent.student_no,
              "schedule_date": currentDate,
              "time_limit_no": `${timeSlot.time_limit_group_no}${subjectInfo.time_division}`,
              "teacher_no": 0,
              "schedule_account_no": 0,
              "schedule_datetime": moment(`${currentDate} ${timeSlot.start_time}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
              "time_division": subjectInfo.time_division,
              "center_no": state.PageformData.selectedStudent.belongs_center_no,
              "classroom_no": state.PageformData.selectedStudent.belongs_classroom_no,
              "course_no": subjectInfo.course_no,
              "course_setting_no": subjectInfo.course_setting_no, // !!
              "subject_no": subjectInfo.subject_no,
              "school_year_code": state.PageformData.selectedStudent.school_year_code,
              "dayofweek_code": dayInfo.dayofweek_code,
              "class_type": subjectInfo.class_type,
              "attendance_distinction": 0,
              "manual_flag": 0,
              "change_flag": 0,
              "entry_schedule_no": subjectInfo.entry_schedule_no || `check.t1030_entry_schedule_week.id.${subjectInfo.id}|get.entry_schedule_no`,
              operation_note: 'add Via C30101-004',
            }

            // add into  t3015_cancel_schedule
            state.t3015_cancel_schedule.push({ ...t3015base })

            // state.t1032_not_attended_schedule.push({...t3015base})

            commit('setState', {
              t3015_cancel_schedule: [...state.t3015_cancel_schedule],
              t1032_not_attended_schedule: [...state.t1032_not_attended_schedule],
            })
          }
          debugMap[currentDate].c = debugMap[currentDate].c ?? 'skip:unknown reason'
          continue;
        }
        debugMap[currentDate].c = 'ok'
        debugMap[currentDate].createdIndex = createdIndex
        createdIndex++
      }
      console.table(debugMap)

      const endDate = moment(currentDate)
        .add(1, 'weeks')
        .day('sunday')
        .format('YYYY-MM-DD');

      state.t1030_entry_schedule_week[index2].course_end_date = endDate
    }
  }
}

export default ObjArrUtils.merge(Base, module)
